/**
 * Primary navigation, declared once and consumed by the desktop header, the
 * mobile nav sheet and (later) the command palette.
 */
export const NAV_LINKS = [
  { to: '/home', label: 'Home' },
  { to: '/wiki', label: 'Wiki' },
  { to: '/about', label: 'About' },
  { to: '/faq', label: 'FAQ' },
  { to: '/rules', label: 'Rules' },
  { to: '/staff', label: 'Staff' },
  { to: '/zeni', label: 'Zeni' },
  { to: '/updates', label: 'Updates' },
  { to: '/howto', label: 'How To' },
];
